module.exports = __webpack_public_path__ + "img/progress_053.e43f870e.png";